import React, { useState } from "react";
import {
  Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle, DialogDescription,
} from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import api from "@/lib/api";
import { toast } from "sonner";
import { useAuth } from "@/lib/auth";

export default function ChangePasswordDialog({ open, onOpenChange, mustChange = false }) {
  const { refreshUser } = useAuth();
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");

  async function submit(e) {
    e.preventDefault();
    setErr("");
    const currentT = current.trim();
    const nextT = next.trim();
    const confirmT = confirm.trim();
    if (nextT.length < 8) { setErr("Almeno 8 caratteri"); return; }
    if (nextT !== confirmT) { setErr("Le password non coincidono"); return; }
    setLoading(true);
    try {
      await api.post("/auth/change-password", { current_password: currentT, new_password: nextT });
      toast.success("Password aggiornata");
      await refreshUser();
      setCurrent(""); setNext(""); setConfirm("");
      onOpenChange(false);
    } catch (e) {
      const d = e.response?.data?.detail;
      setErr(typeof d === "string" ? d : "Errore");
    } finally { setLoading(false); }
  }

  return (
    <Dialog open={open} onOpenChange={mustChange ? undefined : onOpenChange}>
      <DialogContent
        className={`max-w-md bg-white ${mustChange ? "[&>button.absolute]:hidden" : ""}`}
        onEscapeKeyDown={(e) => mustChange && e.preventDefault()}
        onPointerDownOutside={(e) => mustChange && e.preventDefault()}
      >
        <DialogHeader>
          <DialogTitle>{mustChange ? "Imposta la tua password" : "Cambia password"}</DialogTitle>
          <DialogDescription>
            {mustChange
              ? "Questo è il tuo primo accesso: scegli una password personale prima di continuare."
              : "Inserisci la password attuale e la nuova password (min. 8 caratteri)."}
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-3">
          <div>
            <Label className="text-xs">Password attuale</Label>
            <Input type="password" required value={current} onChange={(e) => setCurrent(e.target.value)} data-testid="pw-current" />
          </div>
          <div>
            <Label className="text-xs">Nuova password</Label>
            <Input type="password" required value={next} onChange={(e) => setNext(e.target.value)} data-testid="pw-new" />
          </div>
          <div>
            <Label className="text-xs">Conferma nuova password</Label>
            <Input type="password" required value={confirm} onChange={(e) => setConfirm(e.target.value)} data-testid="pw-confirm" />
          </div>
          {err && <div className="text-sm text-red-700 bg-red-50 border border-red-200 rounded px-3 py-2">{err}</div>}
          <DialogFooter className="mt-2">
            {!mustChange && <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>Annulla</Button>}
            <Button type="submit" disabled={loading} data-testid="pw-submit" className="bg-[#1C352D] hover:bg-[#264A3E]">
              {loading ? "Aggiornamento…" : "Aggiorna password"}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
